import React, { useEffect, useState } from "react";
import * as Constants from "../../constants";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useSelector } from "react-redux";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { t, lookups } from "../../content";
import { useLocale } from "../../locale";

const RadarChartInfo = ({
  title,
  tabActiveKey,
  radarLabel,
  radarLabelDesc,
  accordionArray,
}) => {
  const { locale } = useLocale();
  const [value, setValue] = useState(0);
  const [subValues, setSubValues] = useState({});

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 0, pr: 3, pb: 3, pl: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleChange = (event, newValue) => {
    if (metrics[newValue]) {
      setValue(newValue);
    }
  };

  const userData = useSelector((state) => state.userData?.all);

  const isTeam = tabActiveKey === Constants.TAB_TEAM_STRENGTHS_KEY;
  const isSales = tabActiveKey === Constants.TAB_SALES_STRENGTHS_KEY;
  const isAdept = tabActiveKey === Constants.TAB_ADEPT_ASPECTS_KEY;

  const tooltips = isTeam
    ? lookups.teamStrengthTooltips
    : isSales
    ? lookups.salesStrengthTooltips
    : {};
  const scaleDescription = isTeam
    ? lookups.teamStrengthScaleDescription
    : isSales
    ? lookups.salesStrengthScaleDescription
    : lookups.adeptScaleDescription;
  const adeptStyles = lookups.adeptStyles || [];
  const metrics = isAdept
    ? adeptStyles.map((style) => style.title)
    : isTeam
    ? lookups.teamStrengthLabels || []
    : isSales
    ? lookups.salesStrengthLabels || []
    : [];

  useEffect(() => {
    if (!isAdept) return;
    const scoresByAspectId = {};
    (lookups.adeptAspectItems || []).forEach((item, index) => {
      scoresByAspectId[item.id] = userData?.adept_aspects_points?.[index];
    });
    setSubValues(scoresByAspectId);
  }, [userData, locale, isAdept]);

  return (
    <div>
      <div className="radar-chart-info-component">
        <div className="title" style={{ margin: "10px 10px 10px 0" }}>
          <p className="m-0">{title}</p>
        </div>
        <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex" }}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: "divider",
              width: 250,
              minWidth: 150,
            }}
          >
            {metrics.map((labelName, index) => (
              <Tab label={labelName} key={index} {...a11yProps(index)} />
            ))}
          </Tabs>
          {metrics.map((labelName, index) => (
            <TabPanel value={value} index={index} key={index}>
              {!isAdept &&
              tabActiveKey !== Constants.TAB_COMPETENCIES_KEY &&
              tabActiveKey !== Constants.TAB_MOTIVATIONS_KEY ? (
                <>
                  <h5 className="grey">{tooltips[labelName]}</h5>
                  <br />
                  <div>
                    <p className="header-font">
                      {t("talents.scale.whenAboveAverage", { label: labelName })}
                    </p>
                    <ul className="list-margin">
                      {scaleDescription[labelName]?.high?.map((scale, scaleIndex) => (
                        <li className="list-font" key={scaleIndex}>
                          <span className="checkmark">&#x2713;</span>{" "}
                          <span>{scale}</span>
                        </li>
                      ))}
                    </ul>
                    <p className="header-font">
                      {t("talents.scale.whenBelowAverage", { label: labelName })}
                    </p>
                    <ul className="list-margin">
                      {scaleDescription[labelName]?.low?.map((scale, scaleIndex) => (
                        <li className="list-font" key={scaleIndex}>
                          <span className="crossmark">&#x2715;</span>{" "}
                          <span>{scale}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : isAdept ? (
                <>
                  <h5 className="grey">{adeptStyles[index]?.description}</h5>
                  <br />
                  <Accordion activeIndex={0}>
                    {(adeptStyles[index]?.aspects || []).map((aspect) => (
                      <AccordionTab
                        key={aspect.id}
                        header={`${aspect.title} ( ${subValues[aspect.id] ?? ""} )`}
                      >
                        <div>
                          <p className="header-font">
                            {t("talents.scale.whenAboveAverage", {
                              label: aspect.title,
                            })}
                          </p>
                          <ul className="list-margin">
                            {lookups.adeptScaleDescription[aspect.id]?.high?.map(
                              (scale, scaleIndex) => (
                                <li className="list-font" key={scaleIndex}>
                                  <span className="checkmark">&#x2713;</span>{" "}
                                  <span>{scale}</span>
                                </li>
                              )
                            )}
                          </ul>
                          <p className="header-font">
                            {t("talents.scale.whenBelowAverage", {
                              label: aspect.title,
                            })}
                          </p>
                          <ul className="list-margin">
                            {lookups.adeptScaleDescription[aspect.id]?.low?.map(
                              (scale, scaleIndex) => (
                                <li className="list-font" key={scaleIndex}>
                                  <span className="crossmark">&#x2715;</span>{" "}
                                  <span>{scale}</span>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </AccordionTab>
                    ))}
                  </Accordion>
                </>
              ) : (
                <>
                  <div className="label-dialog-content">
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        style={{ marginBottom: "20px", textAlign: "center" }}
                      >
                        <span
                          style={{
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          {radarLabel}
                        </span>
                      </div>
                      <div style={{ margin: "0 10px 15px 10px" }}>
                        <span style={{ fontStyle: "italic" }}>
                          {radarLabelDesc}
                        </span>
                      </div>
                      <Accordion>
                        {accordionArray?.map((item, accordionIndex) => (
                          <AccordionTab
                            key={accordionIndex}
                            header={item.title}
                            headerClassName="accordian-header-class"
                          >
                            <ul>
                              {item.content.map(
                                (contentItem, contentIndex) => (
                                  <li
                                    className="list-style-disc"
                                    key={contentIndex}
                                  >
                                    {contentItem}
                                  </li>
                                )
                              )}
                            </ul>
                          </AccordionTab>
                        ))}
                      </Accordion>
                    </div>
                  </div>
                </>
              )}
            </TabPanel>
          ))}
        </Box>
      </div>
    </div>
  );
};

export default RadarChartInfo;
